import React from 'react';
import JavascriptDatesFormats from './JavascriptDatesFormats.jsx';
import JavascriptDatesGet from './JavascriptDatesGet.jsx';
import JavascriptDatesSet from './JavascriptDatesSet.jsx';
import JavascriptDatesReference from './JavascriptDatesReference.jsx';

export default function JsDates() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Dates</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/dates/formats' className='underline'>JS Date Formats</a></li>
<li><a href='/javascript/dates/get' className='underline'>JS Date Get</a></li>
<li><a href='/javascript/dates/set' className='underline'>JS Date Set</a></li>
<li><a href='/javascript/dates/reference' className='underline'>JS Date Reference</a></li>
      </ul>
    </div>
  );
}
